import './App.css';
import Navbar from './Component/navbar';

function App() {
  return (
    <div>
      <Navbar />
    </div>
  );
}

export default App;